'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/.1.4.0@intl-messageformat-parser/index.js
// module id = 1088
// module chunks = 1